import { TypeCartWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

import Cart from './Cart'

const mapPriceToggleBlock = (props) => props.fields.priceToggle.props.block
const mapDropDownYearTerm = (props) => props.fields.dropDownYearTerm.props.block

const ContentfulCart = withContentful<TypeCartWithoutUnresolvableLinksResponse['fields']>(Cart, {
  priceToggle: (props) => {
    return <BlockRenderer block={props.fields.priceToggle} fieldPath={'.priceToggle'} />
  },
  priceToggleBlock: mapPriceToggleBlock,
  stickyCartPrice: (props) => {
    return props.fields.stickyCartPrice
  },
  productDetails: (props) => {
    return props.fields?.productDetails?.map((product) => {
      return {
        productId: product.sys.id,
        productIcon: product.fields.productIcon,
        productColor: product.fields.productColor,
        productName: product.fields.productName,
        productNameWithCoupon: product.fields.productNameWithCoupon,
        productPrice: product.fields.productPrice,
        productCouponPrice: product.fields.productCouponPrice,
        productPriceText: product.fields.productPriceText,
        productCouponPriceText: product.fields.productCouponPriceText,
        productNameThreeYearTermToggleOff: product.fields.productNameThreeYearTermToggleOff,
        productPriceThreeYearTermToggleOff: product.fields.productPriceThreeYearTermToggleOff,
        productPriceTextThreeYearTermToggleOff: product.fields.productPriceTextThreeYearTermToggleOff,
        productNameThreeYearTermToggleOn: product.fields.productNameThreeYearTermToggleOn,
        productPriceThreeYearTermToggleOn: product.fields.productPriceThreeYearTermToggleOn,
        productPriceTextThreeYearTermToggleOn: product.fields.productPriceTextThreeYearTermToggleOn,
        productNameFiveYearTermToggleOff: product.fields.productNameFiveYearTermToggleOff,
        productPriceFiveYearTermToggleOff: product.fields.productPriceFiveYearTermToggleOff,
        productPriceTextFiveYearTermToggleOff: product.fields.productPriceTextFiveYearTermToggleOff,
        productNameFiveYearTermToggleOn: product.fields.productNameFiveYearTermToggleOn,
        productPriceFiveYearTermToggleOn: product.fields.productPriceFiveYearTermToggleOn,
        productPriceTextFiveYearTermToggleOn: product.fields.productPriceTextFiveYearTermToggleOn,
      }
    })
  },
  cartSecondaryButtonFields: (props) => {
    return props.fields.cartSecondaryButton ? true : false
  },
  cartSecondaryButton: (props) => {
    return <BlockRenderer block={props.fields.cartSecondaryButton} />
  },
  dropDownYearTerm: (props) => {
    return <BlockRenderer block={props.fields.dropDownYearTerm} fieldPath={'.dropDownYearTerm'} />
  },
  dropDownYearTermBlock: mapDropDownYearTerm,
  cartPrice: (props) => {
    return {
      priceFiveYearWithToggleOff: props.fields.stickyCartPrice.fields.priceFiveYearWithToggleOff,
      priceFiveYearWithToggleOn: props.fields.stickyCartPrice.fields.priceFiveYearWithToggleOn,
      priceThreeYearWithToggleOff: props.fields.stickyCartPrice.fields.priceThreeYearWithToggleOff,
      priceThreeYearWithToggleOn: props.fields.stickyCartPrice.fields.priceThreeYearWithToggleOn,
      priceWithToggleOff: props.fields.stickyCartPrice.fields.priceWithToggleOff,
      priceWithToggleOn: props.fields.stickyCartPrice.fields.priceWithToggleOn,
      stickyCartPriceSignDirection: props.fields.stickyCartPrice.fields.stickyCartPriceSignDirection,
      stickyCartPriceSize: props.fields.stickyCartPrice.fields.stickyCartPriceSize,
      stickyCartRateText: props.fields.stickyCartPrice.fields.stickyCartRateText,
      strikePriceFiveYearWithToggleOff: props.fields.stickyCartPrice.fields.strikePriceFiveYearWithToggleOff,
      strikePriceFiveYearWithToggleOn: props.fields.stickyCartPrice.fields.strikePriceFiveYearWithToggleOn,
      strikePriceRateText: props.fields.stickyCartPrice.fields.strikePriceRateText,
      strikePriceSignDirection: props.fields.stickyCartPrice.fields.strikePriceSignDirection,
      strikePriceSize: props.fields.stickyCartPrice.fields.strikePriceSize,
      strikePriceThreeYearWithToggleOff: props.fields.stickyCartPrice.fields.strikePriceThreeYearWithToggleOff,
      strikePriceThreeYearWithToggleOn: props.fields.stickyCartPrice.fields.strikePriceThreeYearWithToggleOn,
      strikePriceWithToggleOff: props.fields.stickyCartPrice.fields.strikePriceWithToggleOff,
      strikePriceWithToggleOn: props.fields.stickyCartPrice.fields.strikePriceWithToggleOn,
    }
  },
  defaultValuesCart: (props) => {
    return {
      primaryButtonHrefWithToggleOff: props.fields.primaryButtonHrefWithToggleOff,
      primaryButtonHrefWithToggleOn: props.fields.primaryButtonHrefWithToggleOn,
      ribbonTextWithToggleOn: props.fields.ribbonTextWithToggleOn,
      ribbonTextWithToggleOff: props.fields.ribbonTextWithToggleOff,
    }
  },
  fiveYearValues: (props) => {
    return {
      primaryButtonHrefFiveYearWithToggleOn: props.fields.primaryButtonHrefFiveYearWithToggleOn,
      primaryButtonHrefFiveYearWithToggleOff: props.fields.primaryButtonHrefFiveYearWithToggleOff,
      ribbonTextFiveYearTermToggleOn: props.fields.ribbonTextFiveYearTermToggleOn,
      ribbonTextFiveYearTermToggleOff: props.fields.ribbonTextFiveYearTermToggleOff,
    }
  },
  threeYearValues: (props) => {
    return {
      primaryButtonHrefThreeYearWithToggleOn: props.fields.primaryButtonHrefThreeYearWithToggleOn,
      primaryButtonHrefThreeYearWithToggleOff: props.fields.primaryButtonHrefThreeYearWithToggleOff,
      ribbonTextThreeYearTermToggleOn: props.fields.ribbonTextThreeYearTermToggleOn,
      ribbonTextThreeYearTermToggleOff: props.fields.ribbonTextThreeYearTermToggleOff,
    }
  },
})

export default ContentfulCart
